import { render, staticRenderFns } from "./MethodBinancePay.vue?vue&type=template&id=ae7baa90&"
import script from "./MethodBinancePay.vue?vue&type=script&lang=js&"
export * from "./MethodBinancePay.vue?vue&type=script&lang=js&"
import style0 from "./MethodBinancePay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports